import ConfirmDialog from "../../Form/ConfirmDialog";
import { DialogProps } from "@mui/material";

interface SettingDialogProps extends DialogProps {
  disableSave?: boolean;
  onClickSave: () => void;
  onClickClose: () => void;
}

export const SettingDialog = (props: SettingDialogProps) => {
  return (
    <ConfirmDialog
      open={props.open}
      disableOk={props.disableSave}
      okLabel="保存"
      onClickOk={() => props.onClickSave()}
      onClickClose={props.onClickClose}
    >
      {props.children}
    </ConfirmDialog>
  );
};
